<template>
    <div>
      <h2 class="text-center center-header support mx-auto">
        We can Support your business
      </h2>
  
      <form ref="formRef" class="support__form mx-auto" @submit.prevent="sendEmail">
        <div class="row">
          <div class="mb-3 col-6">
            <input
              type="text"
              class="form-control"
              placeholder="First Name"
              v-model="formData.first_name"
              name="first_name"
              required
            />
          </div>
          <div class="mb-3 col-6">
            <input
              type="text"
              class="form-control"
              placeholder="Last Name"
              v-model="formData.last_name"
              name="last_name"
              required
            />
          </div>
        </div>
  
        <div class="mb-3">
          <input
            type="text"
            class="form-control"
            placeholder="Company Name"
            v-model="formData.company_name"
            name="company_name"
            required
          />
        </div>
  
        <div class="mb-3">
          <input
            type="text"
            class="form-control"
            placeholder="NSOC ID / ORDER ID / CIRCUIT ID"
            v-model="formData.nsoc_id"
            name="nsoc_id"
            required
          />
        </div>
  
        <div class="mb-3">
          <input
            type="email"
            class="form-control"
            placeholder="Email"
            v-model="formData.email"
            name="email"
            required
          />
        </div>
  
        <div class="mb-3">
    <vue-tel-input
      v-model="formData.phone"
      :default-country="'ES'"
      placeholder="Enter phone number"
      input-class="form-control"
      name="phone"
      required
    />
  </div>

  
        <div class="mb-3">
          <select
            class="form-select"
            v-model="formData.region"
            name="region"
            required
          >
            <option value="region" disabled>Region</option>
            <option value="singapore">Singapore</option>
            <option value="malaysia">Malaysia</option>
            <option value="rest-asia">Rest of Asia</option>
            <option value="australia-newzealand">Australia & New Zealand</option>
            <option value="europe">Europe</option>
            <option value="middle-east">Middle East</option>
            <option value="north America">North America</option>
            <option value="south America">South America</option>
            <option value="africa">Africa</option>
            <option value="others">Others</option>
          </select>
        </div>
  
        <div class="mb-3">
          <textarea
            class="form-control"
            rows="3"
            placeholder="Please share your concern"
            v-model="formData.message"
            name="message"
            required
          ></textarea>
        </div>
  
        <div class="form-check mb-3 general__box">
          <input
            class="form-check-input"
            type="checkbox"
            id="partnerFormAgree"
            v-model="formData.agreedToTerms"
            required
          />
          <label class="form-check-label" for="partnerFormAgree">
            Agree to terms and conditions of the
            <router-link to="/privacy-policy">privacy policy</router-link>.
          </label>
        </div>
  
        <div class="text-center">
          <button type="submit" class="button">Submit</button>
        </div>
      </form>
    </div>
  </template>
  
  <script>
  import emailjs from 'emailjs-com';
  import Swal from 'sweetalert2';
  import { ref, reactive, onMounted } from 'vue';
  
  export default {
    name: 'SupportPage',
    setup() {
      const formRef = ref(null);
      const formData = reactive({
        first_name: '',
        last_name: '',
        company_name: '',
        nsoc_id: '',
        email: '',
        phone: '',
        region: 'region',
        message: '',
        agreedToTerms: false,
      });
  
      onMounted(() => {
        window.scrollTo(0, 0);
      });
  
      const showAlert = (success) => {
        const alertConfig = {
          title: success ? 'Success' : 'Wait',
          text: success
            ? 'We have received your form, we will review the information and get back to you soon.'
            : 'You need to fill in all the data',
          icon: success ? 'success' : 'info',
          timer: 3000,
          timerProgressBar: true,
        };
  
        Swal.fire(alertConfig);
      };
  
      const sendEmail = async () => {
        try {
          await emailjs.sendForm(
            'service_cxy3wvs',
            'template_fl2oq9j',
            formRef.value,
            'XTHb8nGPkWwJjz2yf'
          );
  
          showAlert(true);
  
         
          Object.assign(formData, {
            first_name: '',
            last_name: '',
            company_name: '',
            nsoc_id: '',
            email: '',
            phone: '',
            region: 'region',
            message: '',
            agreedToTerms: false,
          });
        } catch (error) {
          console.error(error.text);
          showAlert(false);
        }
      };
  
      return {
        formRef,
        formData,
        sendEmail,
      };
    },
  };
  </script>
  
  <style src="@/assets/css/ContactSupport.css"></style>
  